import React from 'react'

const Visited = () => {
  return (
    <div>

<section class="process-section">
        <div class="container">
            <h2>OUR SUCCESS</h2>
            <h3>See How It Works</h3>
            <div class="row justify-content-center">
                <div class="col-md-3 step">
                    <div class="step-circle">250</div>
                    <div class="step-title">PVC PANNEL </div>
                   
                </div>
                <div class="col-md-3 step">
                    <div class="step-circle">200</div>
                    <div class="step-title">PVC DOOR </div>
                    
                </div>
                <div class="col-md-3 step">
                    <div class="step-circle">120</div>
                    <div class="step-title">FLOORING  </div>
                   
                </div>
                <div class="col-md-3 step">
                    <div class="step-circle">150</div>
                    <div class="step-title">FOAM SHEET   </div>
                   
                </div>
            </div>
        </div>
    </section>


    </div>
  )
}

export default Visited